<h1>Enrollment Cancelled</h1>

<section>
<p>You have been removed from enrollment. If you change your, you can easily re-enroll.
<p><a href="/status-notenrolled">Re-enroll Now</a>
<p>(Alert Ryan by email or other way?)
</section>
